"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

require("../RichTextEditor.css");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var FormatToolbar = function FormatToolbar(props) {
  return _react["default"].createElement("div", {
    className: "kt-rte-format-toolbar"
  }, _react["default"].createElement("div", {
    style: {
      margin: '0px 4px'
    }
  }, props.children));
};

var _default = FormatToolbar;
exports["default"] = _default;